<template>
    <div>
        <p v-html="$t('DeviceTest.WebcamTest.Confirm')"></p>

        <div class=" py-2">
            {{ $t('DeviceTest.WebcamTest.Select') }}<select id="camera-select" name="camera-select"></select>
        </div>
        <video id="webcam-output"></video>
    </div>
</template>

<script>
export default {
    name: 'videoTest',
    data () {
        return {
            selectedCamera: '',
            selectedCameraName: '',
        }
    },
    mounted(){
        if (hasGetUserMedia()) {
            // Good to go!
        } else {
            alert('getUserMedia() is not supported by your browser');
        }
        
        function hasGetUserMedia() {
            return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
        }

        this.$nextTick(function () {
            this.askForPermission();

            document.querySelector('#camera-select').onchange = () => {
                let new_selection = document.querySelector('#camera-select').children[
                    document.querySelector('#camera-select').selectedIndex
                ].value;
                this.selectedCameraName = document.querySelector('#camera-select').children[
                    document.querySelector('#camera-select').selectedIndex
                ].text;
                this.selectedCamera = new_selection;
                console.log(this.selectedCamera);
                this.setCamera();
            };
            
            navigator.mediaDevices.ondevicechange = event => {
                document.querySelector('#camera-select').innerHTML = '';
                this.askForPermission();
            }   
        })
    },
    methods:{
        askForPermission:function(){
            var constraints = { video : true };
            navigator.mediaDevices.getUserMedia(constraints)
            .then(() => {
                this.populateCameraList();
                this.GLOBAL.VideoOK = true;
            })
            .catch(() => {
                let item = document.createElement('option');
                item.innerHTML = this.$t('DeviceTest.WebcamTest.NoDevice');
                document.querySelector('#camera-select').appendChild(item);
                this.GLOBAL.VideoOK = false;
            });
        },
        populateCameraList:function(){
            document.querySelector('#camera-select').innerHTML = '';
            navigator.mediaDevices.enumerateDevices().then((deviceList) => {
                // console.log(deviceList);

                this.selectedCamera = deviceList.filter((x) => x.kind == 'videoinput')[0].deviceId;
                this.selectedCameraName = deviceList.filter((x) => x.kind == 'videoinput')[0].label;
                this.setCamera();
                this.GLOBAL.videoOK = true;

                deviceList.forEach((device) => {
                    if (device.kind == 'videoinput') {
                        console.log(device.label);
                        let item = document.createElement('option');
                        // item.setAttribute("value", device.label);
                        // item.value = device.deviceId;
                        item.text = device.deviceId;
                        if(device.label == ""){
                            item.innerHTML = this.$t('DeviceTest.Default');
                        }else{
                            item.innerHTML = device.label;
                        }
                        document.querySelector('#camera-select').appendChild(item);
                    }
                });
            });
        },
        setCamera:function(){
            if (window.stream) {
                window.stream.getTracks().forEach(track => {
                    track.stop();
                });
            }

            // this.GLOBAL.selectedCamera = this.selectedCamera;
            this.GLOBAL.selectedCamera = this.selectedCameraName;
            var constraints = {
                video: {
                    deviceId: this.selectedCamera ? {exact: this.selectedCamera} : undefined,
                    width: { min: 320, ideal: 480, max: 1920 },
                    height: { min: 240, ideal: 360, max: 1080 }
                }
            };

            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                let video = document.querySelector('#webcam-output');
                video.setAttribute("playsinline", true);
                window.stream = stream; // make stream available to console
                video.srcObject = stream;
                video.play();
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/DeviceTestPages/videoTest.vue